import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserCreatePage } from './user-create.component';
import { authGuard } from '@guards/auth.guard';
import { hasRoleGuard } from '@guards/has-role.guard';

const routes: Routes = [
  {
    path: 'crear-usuario',
    component: UserCreatePage,
    canActivate: [authGuard, hasRoleGuard(null, ['usuarios_create'])],
    data: {
      title: "Crear usuario"
    }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class UserCreatePageRoutingModule { }
